// extracted by mini-css-extract-plugin
export default {"root":"Loader_root__myEhF","loader":"Loader_loader__+lRPl","spin":"Loader_spin__E4RJ0","loaderAjax":"Loader_loaderAjax__15HaF"};